import React from 'react';

const faqs = [
  {
    question: "How many tags should I use for my YouTube videos?",
    answer: "YouTube allows up to 500 characters for tags. We recommend using 10-15 relevant tags per video, focusing on quality and relevance rather than quantity."
  },
  {
    question: "How does the AI generate relevant tags?",
    answer: "Our AI analyzes your video title, description, and category to generate relevant tags. It also considers current trends and popular search terms in your content category."
  },
  {
    question: "Should I use the same tags for all my videos?",
    answer: "While some branded tags can be consistent, it's best to customize tags for each video based on its specific content. Our generator helps create unique, relevant tags for each video."
  },
  {
    question: "How important are tags for video visibility?",
    answer: "Tags are one of several factors that influence YouTube SEO. While not as crucial as titles and descriptions, well-chosen tags can help your video appear in search results and suggested videos."
  },
  {
    question: "Can I edit the generated tags?",
    answer: "Yes! You can modify, add, or remove any generated tags to better match your content. The generator provides a starting point that you can customize."
  },
  {
    question: "How often should I update my video tags?",
    answer: "Consider updating tags periodically, especially if you notice changes in trending topics or search patterns in your niche. Our generator stays current with the latest trends."
  }
];

export default function YouTubeFAQ() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          YouTube Tags FAQ
        </h2>
        
        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-red-50 p-6 rounded-lg transform transition-all duration-300 hover:scale-[1.02]">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}